import iziToast from 'izitoast';

export const showCustomToast  = (message: string) => {
    iziToast.info({
        backgroundColor:'#383E45',
        messageColor:'rgba(255, 255, 255, 0.85)',
        maxWidth: 414,
        message: `
        <div class="flex align-senter px-[20px] py-[15px] rounded-[4px]">
<div class="flex-shrink-0 mr-[15px]"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M12 0C18.6281 0 24 5.37187 24 12C24 18.6281 18.6281 24 12 24C5.37187 24 0 18.6281 0 12C0 5.37187 5.37187 0 12 0ZM9.67969 7.48828C9.21328 7.48828 8.83594 7.86562 8.83594 8.33203C8.83594 8.79844 9.21328 9.17578 9.67969 9.17578H11.0859V16.5371H9.08887C8.62268 16.5372 8.24533 16.9147 8.24512 17.3809C8.24512 17.8472 8.62255 18.2245 9.08887 18.2246H14.7705C15.2368 18.2245 15.6143 17.8472 15.6143 17.3809C15.614 16.9147 15.2367 16.5372 14.7705 16.5371H12.7734V8.33203C12.7734 7.86562 12.3961 7.48828 11.9297 7.48828H9.67969ZM11.9297 4.32422C11.4633 4.32422 11.0859 4.70156 11.0859 5.16797C11.0859 5.63438 11.4633 6.01172 11.9297 6.01172C12.3961 6.01172 12.7734 5.63438 12.7734 5.16797C12.7734 4.70156 12.3961 4.32422 11.9297 4.32422Z" fill="white" fill-opacity="0.65"/>
</svg></div>
<div class="text-[14px] font-normal">${message}</div>
</div>
`,
        position: "topCenter",
        progressBar: false,
        messageSize:'14px',
        closeOnClick: true,
        onOpening: () => {
            const toast = document.querySelector('.iziToast') as HTMLElement;
            const toastBody = document.querySelector('.iziToast-body') as HTMLElement;
            const toastClose = document.querySelector('.iziToast-close') as HTMLElement;
            toastClose.style.display = "none";
            toastBody.style.padding = '0';
            toast.style.zIndex = "10000";
            toast.style.position = "fixed";
            toast.style.top = "50%";
            toast.style.left = "50%";
            toast.style.transform = "translate(-50%, -50%)";
        },
    });
}